import { Elena, html, nothing } from "@elenajs/core";
import "../md-button/md-button.js";

export default class MdCallout extends Elena(HTMLElement) {
  static tagName = "md-callout";
  static props = ["badge", "variant", "icon", "href"];

  /** @property @type {"default" | "primary" | "danger"} */
  variant = "default";

  /** @property @type {string} */
  icon = "";

  /** @property @type {string} */
  href = "";

  renderDefault() {
    return html`
      <div class="md-callout chonk rounded">
        ${this.badge ? html`<span>${this.badge}</span>` : nothing} ${this.text}
        ${this.icon ? html`<i class="${this.icon}"></i>` : nothing}
      </div>
    `;
  }

  renderLink() {
    return html`
      <a href="${this.href}" class="md-callout chonk rounded">
        ${this.badge ? html`<span>${this.badge}</span>` : nothing} ${this.text}
        ${this.icon ? html`<i class="${this.icon}"></i>` : nothing}
      </a>
    `;
  }

  render() {
    return this.href ? this.renderLink() : this.renderDefault();
  }
}
MdCallout.define();
